import React from "react";
import { motion } from "framer-motion";
import { Zap, Trophy, Flame, Target, Award, Calendar } from "lucide-react";

const challenges = [
    {
        title: "Lift 5,000kg Today",
        sub: "Daily volume challenge",
        xp: "+120 VP",
        Icon: Zap,
        tone: "from-violet-500/25 to-violet-500/5",
        ring: "ring-violet-400/30",
        rotate: -3,
    },
    {
        title: "Voro Bench Week",
        sub: "Weekly featured",
        xp: "+500 VP",
        Icon: Trophy,
        tone: "from-amber-500/20 to-orange-500/5",
        ring: "ring-amber-300/30",
        rotate: -2,
    },
    {
        title: "Gym vs Gym",
        sub: "Iron Peak vs Revo · Live",
        xp: "Team",
        Icon: Flame,
        tone: "from-rose-500/20 to-violet-500/5",
        ring: "ring-rose-300/30",
        rotate: 3,
    },
    {
        title: "30-Day Streak",
        sub: "Show up. Every day.",
        xp: "Achievement",
        Icon: Award,
        tone: "from-violet-500/25 to-fuchsia-500/10",
        ring: "ring-violet-300/30",
        rotate: -1,
    },
];

const ChallengeCard = ({ c, i }) => {
    const Icon = c.Icon;
    return (
        <motion.div
            initial={{ opacity: 0, y: 30, rotate: 0 }}
            whileInView={{ opacity: 1, y: 0, rotate: c.rotate }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ delay: i * 0.07, duration: 0.6 }}
            whileHover={{ y: -6, rotate: 0, scale: 1.02 }}
            className={`relative rounded-2xl border border-white/10 bg-gradient-to-br ${c.tone} backdrop-blur-xl p-5 ring-1 ${c.ring} shadow-[0_20px_60px_-30px_rgba(139,92,246,0.6)]`}
        >
            <div className="flex items-start justify-between">
                <div className="inline-grid place-items-center h-10 w-10 rounded-xl bg-white/[0.06] border border-white/10 text-violet-200">
                    <Icon size={18} />
                </div>
                <span className="rounded-full bg-violet-500/20 border border-violet-400/30 text-violet-200 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1">
                    {c.xp}
                </span>
            </div>
            <div className="mt-5 font-display text-lg md:text-xl font-extrabold leading-tight">
                {c.title}
            </div>
            <div className="mt-1 text-xs text-white/60">{c.sub}</div>

            {/* Progress bar */}
            <div className="mt-5">
                <div className="flex items-center justify-between text-[10px] text-white/45 uppercase tracking-wider mb-1.5">
                    <span>Progress</span>
                    <span>{Math.floor(40 + Math.random() * 50)}%</span>
                </div>
                <div className="h-1.5 rounded-full bg-white/10 overflow-hidden">
                    <div
                        className="h-full rounded-full"
                        style={{
                            width: `${50 + i * 6}%`,
                            background:
                                "linear-gradient(90deg, #a855f7, #8b5cf6, #6d28d9)",
                        }}
                    />
                </div>
            </div>
        </motion.div>
    );
};

export const ChallengeShowcase = () => {
    return (
        <div
            data-testid="challenge-showcase"
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5"
        >
            {challenges.map((c, i) => (
                <ChallengeCard key={c.title} c={c} i={i} />
            ))}
        </div>
    );
};

export default ChallengeShowcase;
